<template>
<div>
    <v-dialog
        v-model="dialog"
        persistent
        :max-width="options.width"
        v-bind:style="{ zIndex: options.zIndex }"
        content-class="">
        <v-form v-model="valid" ref="form">
            <v-card class="dialog-card">
                <v-card-title class="title blue-title pa-3 pt-4 ml-2 justify-content-center">
                    TESOL Registration Information Review
                    <!-- <div class="header-close" title="close" @click="closeFeedbackDialog"><v-icon>close</v-icon></div> -->
                </v-card-title>
                <v-card-text>   
                    <v-container pt-0 px-2 fluid>
                        <v-layout row wrap>
                            <v-flex xs4 pr-5>
                                <v-flex xs12 class="text-xs-left">
                                    <v-subheader>First Name</v-subheader>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model.trim="tesolForm.FirstName" single-line outline box :error-messages="$v.tesolForm.FirstName.$error ? 'Required': ''" @input="$v.tesolForm.FirstName.$touch()" placeholder="ID First Name" class="body-2"></v-text-field>
                                </v-flex>
                            </v-flex>
                            <v-flex xs4 pr-5>
                                <v-flex xs12 class="text-xs-left">
                                    <v-subheader>Middle Name</v-subheader>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model="tesolForm.MiddleName" single-line outline box @input="$v.tesolForm.MiddleName.$touch()" placeholder="ID Middle Name or leave the field blank" class="body-2"></v-text-field>
                                </v-flex>
                            </v-flex>
                            <v-flex xs4 pr-5>
                                <v-flex xs12 class="text-xs-left">
                                    <v-subheader>Last Name</v-subheader>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model.trim="tesolForm.LastName" single-line outline box :error-messages="$v.tesolForm.LastName.$error ? 'Required': ''" @input="$v.tesolForm.LastName.$touch()" placeholder="ID Last Name" class="body-2"></v-text-field>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs4 pr-5>
                                <v-flex xs12 class="text-xs-left">
                                    <v-subheader>Birthday</v-subheader>
                                </v-flex>
                                <v-flex xs12>
                                    <v-menu v-model="profileDatePicker1" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="formatBirthday" single-line outline box v-on="on" class="body-2" :error-messages="$v.tesolForm.Birthday.$error ? 'Required': ''" @input="$v.tesolForm.Birthday.$touch()" readonly></v-text-field>
                                        </template>
                                        <v-date-picker v-model="tesolForm.Birthday" class="body-2" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @input="profileDatePicker1 = false;formatBirthday = formatDate(tesolForm.Birthday)"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-flex>
                            <v-flex xs4 pr-5>
                                <v-flex xs12 class="text-xs-left">
                                    <v-subheader>Government-issued ID Number</v-subheader>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model.trim="tesolForm.IDNumber" single-line outline box placeholder="Government-issued ID Number" :error-messages="$v.tesolForm.IDNumber.$error ? 'Required': ''"  @input="$v.tesolForm.IDNumber.$touch()" class="body-2"></v-text-field>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                        <!-- <v-layout row wrap>
                            <v-flex xs12>
                                <v-layout row wrap>
                                    <v-flex xs4 pr-5>
                                        <v-flex xs12>
                                            <v-subheader>
                                                TESOL Certificate
                                            </v-subheader>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-autocomplete :items="certificate" v-model="tesolForm.HasTESOLCertificate" single-line outline box :error-messages="$v.tesolForm.HasTESOLCertificate.$error ? 'Required': ''" @input="$v.tesolForm.HasTESOLCertificate.$touch()" class="body-2" placeholder="==Choose=="></v-autocomplete>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs4 pr-5 v-if="tesolForm.HasTESOLCertificate">
                                        <v-flex xs12>
                                            <v-subheader>
                                                Attachment Name
                                            </v-subheader>
                                        </v-flex>
                                        <v-flex xs12>
                                            <input v-show="0" type="file" class="upload" @change="changeTESOLCertificate" ref="inputer" multiple id="personalTESOLCertificateFile" accept=".jpg,.png" />
                                            <v-text-field v-model="TESOLCertificate" single-line outline box :error-messages="$v.TESOLCertificate.$error ? 'Required': ''" @input="$v.TESOLCertificate.$touch()" class="body-2" disabled></v-text-field>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs4 pr-5 v-if="tesolForm.HasTESOLCertificate">
                                        <v-btn class="text-none white--text blue-button upload-btn" @click="replaceTESOLCertificate">
                                        <v-icon dark left
                                            >cloud_upload</v-icon>Click to Upload</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout> -->

                        <v-layout>
                            <v-flex xs12 class="text-xs-center py-3 mt-3">
                                <v-btn class="text-none red-button tesol-dialog-submit" @click="submitTesolInfos()" :loading="tesolFormLoading">Confirm</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

            </v-card>
        </v-form>
    </v-dialog>
    <v-dialog lazy
              v-model="confirmDialog"
              max-width="400"
              @keydown.esc="cancel"
              style="{ zIndex: 999 }"
              :persistent="true"
              content-class="custom-dialog refresh-dialog">
      <v-card>
        <v-toolbar color="white"
                   dense
                   flat>
        </v-toolbar>
        <div>
          <p class="custom-icon">
            <v-icon color="#EE344C">error</v-icon>
          </p>
          <v-card-text class='align-center blue-title'>Your Personal Information shall not be changed or altered upon submission！</v-card-text>

          <div class="custom-footer">
            <v-btn class="text-none blue-button dialog-submit"
                   @click.native="noConfirm"
                   round>Cancel</v-btn>
            <v-btn class="text-none gray-button dialog-submit"
                   @click.native="toConfirm"
                   round>Confirm</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
</div>
</template>
<script>
import { formatDate } from "@/utils/date.js"
import { getTESOLInformationReview, saveTESOLInformation } from '@/api/teachinfo'
import vmodel from "@/mixins/v-model";
import { validationMixin } from "vuelidate";
import {
    required,
    minLength,
    requiredIf,
    maxLength
} from "vuelidate/lib/validators";

import { uploader } from "@/utils/patchUpload.js";
import { _debounce } from "@/utils/tools.js";

export default {
    mixins: [vmodel, validationMixin],
    validations() {
        return {
            tesolForm: {
                FirstName: { required },
                MiddleName: { required, minLength: minLength(1) },
                LastName: { required },
                Birthday: { required },
                IDNumber: { required },
                // HasTESOLCertificate:{ required }
            },
            TESOLCertificate: { required: requiredIf(function(tesolForm) {
                    return this.tesolForm.HasTESOLCertificate
                }) 
            }
        };
    },
    data:()=>({
        tesolFormLoading: false,
        valid: false,
        options:{
            width: 1000,
            zIndex: 200
        },
        dialog: false,
        tesolForm:{
            FirstName: '',
            TESOLCertificate:'',
            HasTESOLCertificate:""
        },
        profileDatePicker1: false,
        formatBirthday: null,
        TESOLCertificateFilesForm: {
            fileUrl: "",
            state: "",
            files: []
        },
        TESOLCertificate: '',
        confirmDialog: false,
        certificate:[
            {value:true,text:'Yes,I have'},
            {value:false,text:"No,I haven't"},
        ]
    }),
    props: {
        tesol: {
            dialog: true
        }
    },
    filters: {
        formatDate(time) {
            return formatDate(time, "MM-dd-yyyy");
        }
    },
    mounted(){
        this.getTESOLInformationReview()
    },
    methods:{
        // acse(val) {
        //     val = val.replace(/[\u4e00-\u9fa5]/g, '');
        //     this.tesolForm.IDNumber = val;
        // },
        formatDate(time) {
            return formatDate(time, "MM-dd-yyyy");
        },
        replaceTESOLCertificate() {
            document.getElementById("personalTESOLCertificateFile").click();
        },
        changeTESOLCertificate(elemt) {
            this.TESOLCertificateFilesForm.files = elemt.target.files;
            this.TESOLCertificate = this.TESOLCertificateFilesForm.files[0].name;
        },
        getTESOLInformationReview(){
            // getTESOLInformationReview().then(res => {
            //     let r = res.data.Body
            //     if(r.ShowReview){
            //         this.dialog = true
            //         this.tesolForm = r.Data
            //         this.tesolForm.Birthday = this.tesolForm.Birthday.split("T")[0]
            //         this.formatBirthday = this.formatDate(this.tesolForm.Birthday);
            //         this.TESOLCertificate = this.tesolForm.TESOLCertificate
            //     }else{
            //        this.dialog = false
            //     }
            // })
            this.dialog = false //去掉tesol弹层20230512

        },
        submitTesolInfos: _debounce(async function() {
            this.$v.tesolForm.$touch();
            this.$v.TESOLCertificate.$touch();
            var test1 = this.$v.tesolForm.FirstName.$model;
            var test2 = this.$v.tesolForm.LastName.$model;
            var test3 = this.$v.tesolForm.Birthday.$model;
            var test4 = this.$v.tesolForm.IDNumber.$model;
            if (test1 =="" || test1==null || test2 =="" || test2==null || test3 =="" || test3==null || test4 =="" || test4==null) {
                console.log("form-error");
                this.tesolFormLoading = false;
                return;
            }
            this.tesolFormLoading = true
            this.confirmDialog = true
          
        }),
        confirmToSubmit: _debounce(async function() {
            let request = {
                FirstName: this.tesolForm.FirstName,
                MiddleName: this.tesolForm.MiddleName,
                LastName: this.tesolForm.LastName,
                Birthday: this.tesolForm.Birthday,
                IDNumber: this.tesolForm.IDNumber,
                HasTESOLCertificate:this.tesolForm.HasTESOLCertificate
            }
            var fileArray=[]
            if(this.TESOLCertificateFilesForm.files && this.TESOLCertificateFilesForm.files.length>0){
                fileArray.push({
                    key:'TesolCertificateSelf',
                    file: this.TESOLCertificateFilesForm.files[0]
                })
            }
            if(fileArray.length>0){
                var _uploader=new uploader({
                    module:'TesolCertificateSelf',
                    progressbar: this.$root.$progressbar,
                    alert: this.$root.$alert
                })
                var uploadResult = await _uploader.uploadBatchWithKey(fileArray)
                if(uploadResult.ErrorCode!=0){
                    this.$root.$alert(uploadResult.Msg||'Upload fail.')
                    return
                }
                var fileData=uploadResult.Body

                if(fileData && fileData["TesolCertificateSelf"]){
                    request.TESOLCertificate = fileData["TesolCertificateSelf"][0]
                }
                
            }
            saveTESOLInformation(request).then(res => {
                this.tesolFormLoading = false;
                if (res.data.ErrorCode === 0) {
                    this.dialog = false
                    this.confirmDialog = false
                }
            })
            
        }),
        noConfirm(){
            this.tesolFormLoading = false
            this.confirmDialog = false
        },
        toConfirm(){
            this.confirmToSubmit()
        }
    }
}
</script>
<style lang="scss">
.v-subheader {
    font-size: 14px;
    padding: 0;
    @include font_color($font-color-theme);
    height: 30px;
}
.tesol-dialog-submit{
    height: 40px!important;
    width: 150px;
    font-size: 16px;
}
.gray-button{
    color: #fff !important;
    background: #aaa !important;
    border-radius: 4px;
    height: 24px;
    min-width: 80px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
</style>
